import { Stack, Typography } from "@mui/material";
import { useContext } from "react";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";

import Context from "../../context";
import CustomReturnBtn from "../DConnectBtn/CustomReturnBtn";

// ----------------------------------------------------------------------

export default function UpdateError() {
	const { customConnectProps } = useContext(Context);
	const { translate } = useLocales();

	return (
		<Stack alignItems={"center"} sx={{ mb: 4 }}>
			<Iconify color={"error.main"} icon={"codicon:error"} width={80} />
			<Typography sx={{ mt: 5, maxWidth: 300 }} variant='subtitle1' textAlign={"center"}>
				{customConnectProps?.updateToken
					? translate("connect_panel.error_update")
					: translate("connect_panel.error_restore")}
			</Typography>
			<Typography
				color={"text.primary"}
				sx={{ mt: 2, maxWidth: 390 }}
				variant='body2'
				fontSize={14}
			>
				{translate("connect_panel.error_des")}
			</Typography>
			<Typography
				color={"text.secondary"}
				fontSize={11}
				sx={{ mt: 2, maxWidth: 350 }}
				variant='body1'
				textAlign={"center"}
			>
				{translate("connect_panel.error_des_2")}
			</Typography>
			<CustomReturnBtn />
		</Stack>
	);
}
